export const CHART_HEIGHT = 190;
export const TICK_PADDING = 12;
